import { Button } from "@vb/ui";
import { formatCryptoCompact } from "../lib/format.js";

interface CashoutButtonProps {
  amount: number;
  multiplier: number;
  currency: string;
  onClick: () => void;
  disabled?: boolean;
}

export function CashoutButton({
  amount,
  multiplier,
  currency,
  onClick,
  disabled,
}: CashoutButtonProps) {
  const payout = amount * multiplier;
  return (
    <Button
      variant="gold"
      fullWidth
      disabled={disabled}
      onClick={onClick}
      style={{ padding: "12px 18px", fontSize: 14 }}
    >
      CASH OUT · {formatCryptoCompact(payout, currency)} {currency}
    </Button>
  );
}
